<template>
  <div class="exhibition">
    <Head></Head>
    <div class="container" v-if="isPhone==false">
      <div class="block1">
        <img alt="xxx" src="../../assets/exhibition/imgs/101.png" style="width: 100%;" />
      </div>
      <div class="block2">
        <img alt="xxx" src="../../assets/exhibition/imgs/102.png" style="width: 100%;" />
      </div>
      <div class="block3">
        <div v-if="navIndex==1">
          <div class="navigation">
            <div class="nav1 navBlue" @click="changeNav1()">
              <span class="navSelect">车展概况</span>
            </div>
            <div class="nav2" @click="changeNav2()">最新信息</div>
            <div class="nav3" @click="changeNav3()">展台亮点</div>
            <div style="clear: both;"></div>
          </div>
          <div class="content1">
            <div class="contain">
              <div class="left">
                <img alt="xxx" src="../../assets/exhibition/imgs/103.png" style="width: 100%;" />
              </div>
              <div class="right">
                <div class="text">
                  6月13日，第22届重庆车展如约而至，热辣开启。
                  <br />上汽大众携多款重磅车型亮相车展，让我们一起相约重庆。
                </div>
              </div>
              <div style="clear: both;"></div>
            </div>
          </div>
        </div>
        <div v-if="navIndex==2">
          <div class="navigation">
            <div class="nav1" @click="changeNav1()">车展概况</div>
            <div class="nav2 navBlue" @click="changeNav2()">
              <span class="navSelect">最新信息</span>
            </div>
            <div class="nav3" @click="changeNav3()">展台亮点</div>
            <div style="clear: both;"></div>
          </div>
          <div class="content2">
            <div class="contain">
              <div
                class="item"
                onclick="window.location='https://www.csvw.com/csvw-website/news/dz-brand-news.html?newsid=2751'"
              >
                <div class="left">
                  <img alt="xxx" src="../../assets/exhibition/imgs/107.png" style="width: 100%;" />
                </div>
                <div class="right">
                  <div class="title-ex">2020重庆车展火热进行时 上汽大众大众品牌实力圈粉</div>
                  <div
                    class="text"
                  >6月中旬，2020重庆国际汽车展览会正在隆重举办。在重庆国际博览中心（重庆·悦来）N3馆，上汽大众大众品牌展台观众络绎不绝，明星车型关注度飙升。大众品牌为何获得如此高人气？让我们走进大众品牌展台，一探背后的秘密。</div>
                </div>
                <div style="clear: both;"></div>
              </div>
              <div
                class="item"
                onclick="window.location='https://www.csvw.com/csvw-website/news/skoda-brand-news.html?newsid=2747'"
              >
                <div class="left">
                  <img alt="xxx" src="../../assets/exhibition/imgs/105.png" style="width: 100%;" />
                </div>
                <div class="right">
                  <div class="title-ex">约起！到重庆车展选辆“嘿巴适”的斯柯达回家</div>
                  <div
                    class="text"
                  >2020年6月13日，2020（第二十二届）重庆国际汽车展览会开幕。斯柯达携柯迪亚克家族、柯珞克、柯米克家族与新速派、明锐、昕锐亮相重庆国际博览中心N3馆。车展期间，斯柯达展台还有丰富的购车钜惠以及精彩的互动游戏等你来耍。</div>
                </div>
                <div style="clear: both;"></div>
              </div>

              <div style="clear: both;"></div>
            </div>
          </div>
        </div>
        <div v-if="navIndex==3">
          <div class="navigation">
            <div class="nav1" @click="changeNav1()">车展概况</div>
            <div class="nav2" @click="changeNav2()">最新信息</div>
            <div class="nav3 navBlue" @click="changeNav3()">
              <span class="navSelect">展台亮点</span>
            </div>
            <div style="clear: both;"></div>
          </div>
          <div class="content3">
            <div class="select-contain">
              <select
                class="select-option"
                id="option"
                v-model="selectItem"
                @change="selectChange()"
              >
                <option
                  v-bind:key="item.id"
                  v-for="item in selectTtems"
                  :value="item.id"
                >{{item.value}}</option>
              </select>
              <div style="clear: both;"></div>
            </div>
            <div class="contain" v-if="sec3Type==1">
              <div v-bind:key="item.text" v-for="item in picsArr" class="box">
                <div class="left" @click="showPop(item.url1)">
                  <img alt="xxx" :src="item.url1" style="width: 100%;" />
                  <div class="text">{{item.text1}}</div>
                </div>
                <div class="middle" @click="showPop(item.url2)">
                  <img alt="xxx" :src="item.url2" style="width: 100%;" />
                  <div class="text">{{item.text2}}</div>
                </div>
                <div class="right" v-if="item.url3" @click="showPop(item.url3)">
                  <img alt="xxx" :src="item.url3" style="width: 100%;" />
                  <div class="text">{{item.text3}}</div>
                </div>
                <div style="clear: both;"></div>
              </div>
            </div>
            <div class="contain" v-if="sec3Type==2">
              <div v-bind:key="item.text" v-for="item in picsArr" class="box">
                <div class="left" @click="showPop(item.url1)">
                  <img alt="xxx" :src="item.url1" style="width: 100%;" />
                </div>
                <div class="middle" @click="showPop(item.url2)">
                  <img alt="xxx" :src="item.url2" style="width: 100%;" />
                </div>
                <div class="right" v-if="item.url3" @click="showPop(item.url3)">
                  <img alt="xxx" :src="item.url3" style="width: 100%;" />
                </div>
                <div style="clear: both;"></div>
              </div>
            </div>
          </div>
          <div class="cover" v-if="showCover"></div>
          <div class="popup" v-if="showCover">
            <div>
              <div class="close" @click="closePop()">
                <img alt="xxx" src="../../assets/exhibition/imgs/106.png" style="width: 100%;" />
              </div>
              <div class="img">
                <img alt="xxx" :src="popUrl" style="width: 100%;" />
              </div>
            </div>
          </div>
        </div>
        <div style="clear: both;"></div>
      </div>
    </div>
    <ExhibitionMobile v-if="isPhone"></ExhibitionMobile>
    <Foot></Foot>
  </div>
</template>

<script>
import { getBrowserType, getBrowserHight } from "../../components/js/screen.js";
import ExhibitionMobile from "./ExhibitionMobile";
import Head from "../../components/header-index.vue";
import Foot from "../../components/footer-index.vue";
export default {
  name: "Exhibition",
  components: {
    ExhibitionMobile,
    Head,
    Foot
  },
  data() {
    return {
      isPhone: false,
      navIndex: 1, // 导航页签
      sec3Type: 1, // 第三个图片的类型
      showCover: false,
      popUrl: require("../../assets/exhibition/imgs/301.jpg"),
      selectItem: "1",
      selectTtems: [
        { id: "1", value: "大众品牌车型" },
        { id: "2", value: "斯柯达品牌车型" },
        { id: "3", value: "车展花絮" }
      ],
      picsArr: [
        {
          text1: "Viloran 威然",
          url1: require("../../assets/exhibition/imgs/301.jpg"),
          text2: "Teramont X 途昂X",
          url2: require("../../assets/exhibition/imgs/302.jpg"),
          text3: "Teramont 途昂",
          url3: require("../../assets/exhibition/imgs/303.jpg")
        }
      ]
    };
  },
  mounted: function() {
    // 判断是否手机
    this.getIsPhone();
    this.setSectionHeight();
    // 浏览器改变大小监听事件
    window.onresize = this.setSectionHeight;
    this.setTitle();
  },
  methods: {
    setSectionHeight() {
      const h = getBrowserHight();
      const height = `${h}px`;
      //document.getElementById("left").style.height = height;
    },
    changeNav1() {
      this.navIndex = 1;
    },
    changeNav2() {
      this.navIndex = 2;
    },
    changeNav3() {
      this.navIndex = 3;
      this.change1();
    },
    getIsPhone() {
      var userAgentInfo = navigator.userAgent;
      var Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod"
      ];
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          this.isPhone = true;
        }
      }
    },
    setTitle() {
      document.title = "重庆车展";
    },
    selectChange() {
      if (this.selectItem == "1") {
        this.change1();
      } else if (this.selectItem == "2") {
        this.change2();
      } else if (this.selectItem == "3") {
        this.change3();
      }
    },
    change1() {
      this.sec3Type = 1;
      this.picsArr = [
        {
          text1: "Viloran 威然",
          url1: require("../../assets/exhibition/imgs/301.jpg"),
          text2: "Teramont X 途昂X",
          url2: require("../../assets/exhibition/imgs/302.jpg"),
          text3: "Teramont 途昂",
          url3: require("../../assets/exhibition/imgs/303.jpg")
        },
        {
          text1: "Tiguan L 途观L",
          url1: require("../../assets/exhibition/imgs/304.jpg"),
          text2: "Tharu 途岳",
          url2: require("../../assets/exhibition/imgs/305.jpg"),
          text3: "T-Cross 途铠",
          url3: require("../../assets/exhibition/imgs/306.jpg")
        },
        {
          text1: "PHIDEON 辉昂",
          url1: require("../../assets/exhibition/imgs/307.jpg"),
          text2: "New Passat 全新一代帕萨特",
          url2: require("../../assets/exhibition/imgs/308.jpg"),
          text3: "New Lamando 全新凌渡",
          url3: require("../../assets/exhibition/imgs/309.jpg")
        },
        {
          text1: "All New Lavida 全新一代朗逸",
          url1: require("../../assets/exhibition/imgs/310.jpg"),
          text2: "New Santana 新桑塔纳",
          url2: require("../../assets/exhibition/imgs/311.jpg"),
          text3: "All New Polo Plus 全新一代 Polo Plus",
          url3: require("../../assets/exhibition/imgs/312.jpg")
        },
        {
          text1: "Passat PHEV 帕萨特插电式混合动力版",
          url1: require("../../assets/exhibition/imgs/313.jpg"),
          text2: "Tiguan L PHEV 途观L插电式混合动力版",
          url2: require("../../assets/exhibition/imgs/314.jpg"),
          text3: "e-Lavida 朗逸纯电",
          url3: require("../../assets/exhibition/imgs/315.jpg")
        }
      ];
    },
    change2() {
      this.sec3Type = 1;
      this.picsArr = [
        {
          text1: "KODIAQ 柯迪亚克",
          url1: require("../../assets/exhibition/imgs/401.jpg"),
          text2: "KAROQ 柯珞克智行款",
          url2: require("../../assets/exhibition/imgs/402.jpg"),
          text3: "KAMIQ 柯米克",
          url3: require("../../assets/exhibition/imgs/403.jpg")
        },
        {
          text1: "KODIAQ GT 柯迪亚克GT",
          url1: require("../../assets/exhibition/imgs/404.jpg"),
          text2: "KAMIQ GT 柯米克GT",
          url2: require("../../assets/exhibition/imgs/405.jpg"),
          text3: "SUPERB 速派",
          url3: require("../../assets/exhibition/imgs/406.jpg")
        },
        {
          text1: "OCTAVIA 明锐智行款",
          url1: require("../../assets/exhibition/imgs/407.jpg"),
          text2: "RAPID 昕锐",
          url2: require("../../assets/exhibition/imgs/408.jpg")
        }
      ];
    },
    change3() {
      this.sec3Type = 2;
      this.picsArr = [
        {
          url1: require("../../assets/exhibition/imgs/501.jpg"),
          url2: require("../../assets/exhibition/imgs/502.jpg"),
          url3: require("../../assets/exhibition/imgs/503.jpg")
        },
        {
          url1: require("../../assets/exhibition/imgs/504.jpg"),
          url2: require("../../assets/exhibition/imgs/505.jpg"),
          url3: require("../../assets/exhibition/imgs/506.jpg")
        },
        {
          url1: require("../../assets/exhibition/imgs/507.jpg"),
          url2: require("../../assets/exhibition/imgs/508.jpg"),
          url3: require("../../assets/exhibition/imgs/509.jpg")
        }
      ];
    },
    showPop(url) {
      this.showCover = true;
      this.popUrl = url;
    },
    closePop() {
      this.showCover = false;
    }
  }
};
</script>

<style scoped>
.container {
  position: relative;
  width: 100%;
  min-width: 1024px;
}
@media screen and (min-width: 1px) {
  .block2 {
    padding: 0 300px;
  }
  /* 导航栏 */
  .navigation {
    position: relative;
    width: 500px;
    text-align: center;
    left: 50%;
    margin-left: -250px;
  }
  .navigation .nav1 {
    position: relative;
    float: left;
    font-size: 24px;
    line-height: 37px;
    color: rgba(51, 51, 51, 1);
    cursor: pointer;
    width: 33%;
  }
  .navigation .nav2 {
    position: relative;
    float: left;
    font-size: 24px;
    line-height: 37px;
    color: rgba(51, 51, 51, 1);
    cursor: pointer;
    width: 33%;
    border-left: solid 1px rgba(51, 51, 51, 1);
    border-right: solid 1px rgba(51, 51, 51, 1);
  }
  .navigation .nav3 {
    position: relative;
    float: left;
    font-size: 24px;
    line-height: 37px;
    color: rgba(51, 51, 51, 1);
    cursor: pointer;
    width: 33%;
  }
  .navigation .navBlue {
    font-weight: bold;
    color: rgba(0, 119, 199, 1);
  }
  .navigation .navSelect {
    border-bottom: solid 2px rgba(0, 119, 199, 1);
    padding-bottom: 10px;
  }

  /* 第一个导航栏 */
  .content1 {
    margin-top: 80px;
    margin-bottom: 40px;
    margin-left: 300px;
    margin-right: 300px;
  }
  .content1 .contain {
    position: relative;
  }
  .content1 .left {
    position: relative;
    float: left;
    width: 50%;
  }
  .content1 .right {
    position: relative;
    float: left;
    width: 50%;
  }
  .content1 .right .text {
    font-size: 20px;
    line-height: 40px;
    color: rgba(51, 51, 51, 1);
    padding-left: 80px;
    padding-top: 120px;
  }
  /* 第二个导航栏 */
  .content2 {
    margin-top: 80px;
    margin-bottom: 40px;
    margin-left: 300px;
    margin-right: 300px;
  }
  .content2 .contain {
    position: relative;
  }
  .content2 .contain .item {
    margin-top: 20px;
    cursor: pointer;
  }
  .content2 .left {
    position: relative;
    float: left;
    width: 30%;
  }
  .content2 .right {
    position: relative;
    float: left;
    width: 70%;
  }

  .content2 .right .title-ex {
    font-size: 20px;
    line-height: 44px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    margin-left: 66px;
    margin-top: 50px;
  }
  .content2 .right .text {
    font-size: 16px;
    line-height: 30px;
    color: rgba(51, 51, 51, 1);
    margin-left: 66px;
    margin-top: 20px;
  }
  /* 第三个导航栏 */
  .content3 {
    margin-top: 80px;
    margin-bottom: 40px;
    margin-left: 300px;
    margin-right: 300px;
  }
  .content3 .select-contain {
  }
  .content3 .select-option {
    position: relative;
    float: right;
    width: 180px;
    height: 30px;
    font-size: 16px;
    line-height: 28px;
    color: rgba(51, 51, 51, 1);
  }
  .content3 .contain {
    position: relative;
    width: 100%;
  }
  .content3 .contain .box {
    position: relative;
    width: 100%;
    margin-top: 40px;
  }
  .content3 .contain .box img {
    cursor: pointer;
  }
  .content3 .contain .box .left {
    position: relative;
    float: left;
    width: calc(33.33333333% - 8px);
    padding-right: 8px;
  }
  .content3 .contain .box .middle {
    position: relative;
    float: left;
    width: calc(33.33333333% - 8px);
    padding-left: 4px;
    padding-right: 4px;
  }
  .content3 .contain .box .right {
    position: relative;
    float: left;
    width: calc(33.33333333% - 8px);
    padding-left: 8px;
  }
  .content3 .contain .text {
    text-align: center;
    font-size: 20px;
    line-height: 24px;
    color: rgba(51, 51, 51, 1);
    font-weight: bold;
    margin-top: 25px;
  }
  .block3 .cover {
    position: fixed;
    /*首先将位置固定住*/
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    /*上下左右设置都为0*/
    background: rgba(2, 2, 2, 0.5);
  }
  .block3 .popup {
    position: fixed;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 800px;
    height: 571.4px;
  }
  .block3 .popup .close {
    position: relative;
    float: right;
    width: 20px;
    cursor: pointer;
  }
}

@media screen and (min-width: 1px) and (max-width: 1300px) {
  .block2 {
    padding: 0 100px;
  }
  /* 导航栏 */
  .navigation {
    position: relative;
    width: 500px;
    text-align: center;
    left: 50%;
    margin-left: -250px;
  }
  .navigation .nav1 {
    position: relative;
    float: left;
    font-size: 16px;
    color: rgba(51, 51, 51, 1);
    cursor: pointer;
    width: 33%;
  }
  .navigation .nav2 {
    position: relative;
    float: left;
    font-size: 16px;
    color: rgba(51, 51, 51, 1);
    cursor: pointer;
    width: 33%;
    border-left: solid 1px rgba(51, 51, 51, 1);
    border-right: solid 1px rgba(51, 51, 51, 1);
  }
  .navigation .nav3 {
    position: relative;
    float: left;
    font-size: 16px;
    color: rgba(51, 51, 51, 1);
    cursor: pointer;
    width: 33%;
  }
  .navigation .navBlue {
    font-weight: bold;
    color: rgba(0, 119, 199, 1);
  }

  /* 第一个导航栏 */
  .content1 {
    margin-top: 80px;
    margin-bottom: 40px;
    margin-left: 100px;
    margin-right: 100px;
  }
  .content1 .contain {
    position: relative;
  }
  .content1 .left {
    position: relative;
    float: left;
    width: 50%;
  }
  .content1 .right {
    position: relative;
    float: left;
    width: 50%;
  }
  .content1 .right .text {
    font-size: 13px;
    line-height: 27px;
    color: rgba(51, 51, 51, 1);
    padding-left: 60px;
    padding-top: 120px;
  }
  /* 第二个导航栏 */
  .content2 {
    margin-top: 80px;
    margin-bottom: 40px;
    margin-left: 100px;
    margin-right: 100px;
  }
  .content2 .contain {
    position: relative;
  }
  .content2 .contain .item {
    margin-top: 20px;
    cursor: pointer;
  }
  .content2 .left {
    position: relative;
    float: left;
    width: 30%;
  }
  .content2 .right {
    position: relative;
    float: left;
    width: 70%;
  }

  .content2 .right .title-ex {
    font-size: 14px;
    line-height: 30px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    margin-left: 45px;
    margin-top: 40px;
  }
  .content2 .right .text {
    font-size: 11px;
    line-height: 20px;
    color: rgba(51, 51, 51, 1);
    margin-left: 45px;
    margin-top: 17px;
  }
  /* 第三个导航栏 */
  .content3 {
    margin-top: 80px;
    margin-bottom: 40px;
    margin-left: 200px;
    margin-right: 200px;
  }
  .content3 .select-contain {
  }
  .content3 .select-option {
    position: relative;
    float: right;
    width: 120px;
    height: 20px;
    font-size: 12px;
    line-height: 18px;
    color: rgba(51, 51, 51, 1);
  }
  .content3 .contain {
    position: relative;
    width: 100%;
  }
  .content3 .contain .box {
    position: relative;
    width: 100%;
    margin-top: 25px;
  }
  .content3 .contain .box img {
    cursor: pointer;
  }
  .content3 .contain .box .left {
    position: relative;
    float: left;
    width: calc(33.33333333% - 8px);
    padding-right: 8px;
  }
  .content3 .contain .box .middle {
    position: relative;
    float: left;
    width: calc(33.33333333% - 8px);
    padding-left: 4px;
    padding-right: 4px;
  }
  .content3 .contain .box .right {
    position: relative;
    float: left;
    width: calc(33.33333333% - 8px);
    padding-left: 8px;
  }
  .content3 .contain .text {
    text-align: center;
    font-size: 13px;
    line-height: 16px;
    color: rgba(51, 51, 51, 1);
    font-weight: bold;
    margin-top: 17px;
  }
  .block3 .cover {
    position: fixed;
    /*首先将位置固定住*/
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    /*上下左右设置都为0*/
    background: rgba(2, 2, 2, 0.5);
  }
  .block3 .popup {
    position: fixed;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 600px;
    height: 428.6px;
  }
  .block3 .popup .close {
    position: relative;
    float: right;
    width: 15px;
    cursor: pointer;
  }
}
@media screen and (min-width: 1301px) and (max-width: 1600px) {
  .block2 {
    padding: 0 134px;
  }
  /* 导航栏 */
  .navigation {
    position: relative;
    width: 500px;
    text-align: center;
    left: 50%;
    margin-left: -250px;
  }
  .navigation .nav1 {
    position: relative;
    float: left;
    font-size: 20px;
    color: rgba(51, 51, 51, 1);
    cursor: pointer;
    width: 33%;
  }
  .navigation .nav2 {
    position: relative;
    float: left;
    font-size: 20px;
    color: rgba(51, 51, 51, 1);
    cursor: pointer;
    width: 33%;
    border-left: solid 1px rgba(51, 51, 51, 1);
    border-right: solid 1px rgba(51, 51, 51, 1);
  }
  .navigation .nav3 {
    position: relative;
    float: left;
    font-size: 20px;
    color: rgba(51, 51, 51, 1);
    cursor: pointer;
    width: 33%;
  }
  .navigation .navBlue {
    font-weight: bold;
    color: rgba(0, 119, 199, 1);
  }

  /* 第一个导航栏 */
  .content1 {
    margin-top: 80px;
    margin-bottom: 40px;
    margin-left: 134px;
    margin-right: 134px;
  }
  .content1 .contain {
    position: relative;
  }
  .content1 .left {
    position: relative;
    float: left;
    width: 50%;
  }
  .content1 .right {
    position: relative;
    float: left;
    width: 50%;
  }
  .content1 .right .text {
    font-size: 16px;
    line-height: 33px;
    color: rgba(51, 51, 51, 1);
    padding-left: 70px;
    padding-top: 100px;
  }
  /* 第二个导航栏 */
  .content2 {
    margin-top: 80px;
    margin-bottom: 40px;
    margin-left: 134px;
    margin-right: 134px;
  }
  .content2 .contain {
    position: relative;
  }
  .content2 .contain .item {
    margin-top: 20px;
    cursor: pointer;
  }
  .content2 .left {
    position: relative;
    float: left;
    width: 30%;
  }
  .content2 .right {
    position: relative;
    float: left;
    width: 70%;
  }

  .content2 .right .title-ex {
    font-size: 14px;
    line-height: 30px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    margin-left: 45px;
    margin-top: 70px;
  }
  .content2 .right .text {
    font-size: 11px;
    line-height: 20px;
    color: rgba(51, 51, 51, 1);
    margin-left: 45px;
    margin-top: 20px;
  }
  /* 第三个导航栏 */
  .content3 {
    margin-top: 80px;
    margin-bottom: 40px;
    margin-left: 250px;
    margin-right: 250px;
  }
  .content3 .select-contain {
  }
  .content3 .select-option {
    position: relative;
    float: right;
    width: 180px;
    height: 30px;
    font-size: 13px;
    line-height: 23px;
    color: rgba(51, 51, 51, 1);
  }
  .content3 .contain {
    position: relative;
    width: 100%;
  }
  .content3 .contain .box {
    position: relative;
    width: 100%;
    margin-top: 40px;
  }
  .content3 .contain .box img {
    cursor: pointer;
  }
  .content3 .contain .box .left {
    position: relative;
    float: left;
    width: calc(33.33333333% - 8px);
    padding-right: 8px;
  }
  .content3 .contain .box .middle {
    position: relative;
    float: left;
    width: calc(33.33333333% - 8px);
    padding-left: 4px;
    padding-right: 4px;
  }
  .content3 .contain .box .right {
    position: relative;
    float: left;
    width: calc(33.33333333% - 8px);
    padding-left: 8px;
  }
  .content3 .contain .text {
    text-align: center;
    font-size: 16px;
    line-height: 20px;
    color: rgba(51, 51, 51, 1);
    font-weight: bold;
    margin-top: 25px;
  }
  .block3 .cover {
    position: fixed;
    /*首先将位置固定住*/
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    /*上下左右设置都为0*/
    background: rgba(2, 2, 2, 0.5);
  }
  .block3 .popup {
    position: fixed;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 700px;
    height: 500px;
  }
  .block3 .popup .close {
    position: relative;
    float: right;
    width: 15px;
    cursor: pointer;
  }
}
</style>